import {
  createContext,
  useEffect,
  useCallback,
  useState,
  useMemo,
  useContext,
} from "react";
import { Outlet, useLocation } from "react-router-dom";
import PriceListService from "../services/PriceListService";
import { ToastContext } from "../providers/ToastProvider";

export const orderContext = createContext([]);

const OrderProvider = () => {
  const location = useLocation();
  const priceListService = useMemo(() => new PriceListService(), []);
  const { setShowToast, setToastMessage } = useContext(ToastContext);
  const [client, setClient] = useState();
  const [clientBranchId, setClientBranchId] = useState();
  const [products, setProducts] = useState([]);

  const addProduct = useCallback(async (product) => {
    try {
      const productResponse = await priceListService.getProduct(client?.priceListId, product.reference);

      const newKey = `${product.id}-${product.size ?? "none"}-${
        product.color ?? "none"
      }`;

      if (products.findIndex((p) => p.key === newKey) > -1) {
        setToastMessage([
          {
            severity: "error",
            primary: `Ya se agrego esta combinanción del producto`,
          },
        ]);
        setShowToast(true);
        return;
      }

      const newProduct = {
        ...product,
        color: product.color ?? "Sin seleccionar",
        size: product.size ?? "Sin seleccionar",
        total: productResponse.data?.result.productPrice * product.quantity,
        key: newKey,
      };

      setProducts((oldProducts) => [...oldProducts, newProduct]);

      setToastMessage([
        {
          severity: "success",
          primary: `Producto/s agregado exitosamente`,
        },
      ]);
      setShowToast(true);
    } catch (error) {
      if (error.response.status === 404) {
        setToastMessage([
          {
            severity: "error",
            primary: `No se encontró el precio para este producto`,
          },
        ]);
        setShowToast(true);
        return;
      }

      setToastMessage([
        {
          severity: "error",
          primary: `Error al agregar el producto`,
        },
      ]);
      setShowToast(true);
    }
  }, [client?.priceListId, priceListService, products, setToastMessage, setShowToast]);

  const deleteProduct = (id) => {
    setProducts((oldProducts) => [
      ...oldProducts.filter((product) => product.key !== id),
    ]);
  };

  useEffect(() => {
    const stateClient = location.state?.client;
    const stateClientBranchId = location.state?.clientBranchId;

    if (!stateClient && !client) {
      return setClient(undefined);
    }

    setClient(stateClient);
    setClientBranchId(stateClientBranchId);
  }, []);

  return (
    <orderContext.Provider
      value={{
        products,
        addProduct,
        deleteProduct,
        client,
        clientBranchId,
      }}
    >
      <Outlet />
    </orderContext.Provider>
  );
};

export default OrderProvider;
